export default new Map([
    [1, "green"],
    [2, "orange"],
    [3, "red"],
    [0, "gray"]
]);